export default "__VITE_ASSET__B5R$Bey6__"